import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      minicartBtn: '[data-minicart-button]',
      minicartContent: '[data-minicart-content]',
      minicartContentNotify: '[data-minicartnotification-content]',
      minicartCount: '[data-minicart-count]:visible',
      minicartMobile: '[data-minicart-mobile]',
      remove: '.js-removeitem',
    };
  }

  get CLASSES() {
    return {
      minicartEmpty: 'mini-cart--empty',
      minicartFull: 'mini-cart--full',
      minicartCounterLive: 'live',
      minicartCounterGoingOut: 'goingOut',
      minicartOpened: 'minicart-opened',
      minicartHidden: 'hidden',
      minicartVisible: 'visible',
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    // general
    this.timeout = null;
    // selectors
    this.minicartBtn = this.$component.querySelector(this.SELECTORS.minicartBtn);
    this.minicartContent = document.querySelectorAll(this.SELECTORS.minicartContent);
    this.minicartCount = $(this.SELECTORS.minicartCount)[0];
    this.minicartMobile = document.querySelector(this.SELECTORS.minicartMobile);
    this.minicartContentNotify = this.$component.querySelector(this.SELECTORS.minicartContentNotify);
  }
  removeProduct(el) {

    let ctx = this;
    let $elem = $(el);
    let $main = $elem.closest(ctx.SELECTORS.quickCart);

    doAjax({
      url: $elem.data('href'),
      dataType: "json",
      type: 'POST',
      success: function (resp) {

        let item = $elem.closest('.product-item');
        let qty = resp.count;
        let tot = resp.totalFormattedPrice;

        item.addClass(ctx.CLASSES.removing);
        setTimeout(() => {
          item.remove()
        }, 800);
        $main.find('.tot-price').text(tot);

        ctx.updateMinicart();

        if (resp.count !== null) {
          ctx.updateQty(resp.count);
        } else {
          /*setTimeout(() => {
            ctx.showEmptyMsg($main)
          }, 800);
          ;*/
        }
        // ctx.updateMinicart();
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }
  updateMinicart() {
    // global
    let ctx = this;
    // params
    let ajaxUrl = this.minicartBtn.getAttribute('data-url');

    return doAjax({
      url: ajaxUrl,
      dataType: "html",
      success: function (resp) {
        ctx.log('Minicart updated...');
        // get the html
        let response = new DOMParser().parseFromString(resp, 'text/html');
        let newCartHtml = response.querySelectorAll(ctx.SELECTORS.minicartContent);
        // replace html
        ctx.minicartContent.forEach((minicart, index) => {
          minicart.innerHTML = newCartHtml[0].innerHTML;
        });
        // update cart counter
        // ctx.updateQty();
        // trigger event
        ctx.$emit(ctx.$customEvents.MINICART_EVENTS.update, {content: newCartHtml});
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  showCounter() {
    // globals
    let ctx = this;
    // wait a little bit, then
    setTimeout(function(){
      ctx.minicartCount.classList.add(ctx.CLASSES.minicartCounterLive);
    },350);
  }

  hideCounter() {
    // remove and add classes
    this.minicartCount.classList.remove(this.CLASSES.minicartCounterLive);
    this.minicartCount.classList.add(this.CLASSES.minicartCounterGoingOut);
  }

  updateQty(qty) {
    // globals
    let ctx = this;
    //
    if (this.minicartCount != null) {
      if (typeof qty === 'undefined' ) {
        qty = this.minicartCount.getAttribute("data-qty");
      }
      // check if i have quantity
      if (parseInt(qty,10) !== null) {
        // if is already shown, remove and show then
        if (this.minicartCount.classList.contains(this.CLASSES.minicartCounterLive)) {
          this.hideCounter();
          // wait a little bit, put html and show counter
          setTimeout(function(){
            // put updated counter html
            $('[data-minicart-count]').each((index, minicart) => {
              minicart.innerHTML = qty;
              minicart.dataset.qty = qty;
            });
            //ctx.minicartCount.innerHTML = qty;
            // remove exiting class
            ctx.minicartCount.classList.remove(ctx.CLASSES.minicartCounterGoingOut);
            // show counter
            ctx.showCounter();
          },350);
        } else {
          // put html and show counter
          this.minicartCount.innerHTML = qty;
          this.showCounter();
        }
        // class for button to show counter
        this.minicartBtn.classList.remove(this.CLASSES.minicartEmpty);
        this.minicartBtn.classList.add(this.CLASSES.minicartFull);
      } else {
        // class for button to hide counter
        this.minicartBtn.classList.remove(this.CLASSES.minicartFull);
        this.minicartBtn.classList.add(this.CLASSES.minicartEmpty);
      }
    }
  }

  closeMinicartNotification() {
    clearTimeout(this.timeout);
    this.minicartContentNotify.classList.remove(this.CLASSES.minicartOpened);
    this.minicartContent.forEach(minicart => {
      minicart.classList.remove(this.CLASSES.minicartHidden);
    })
    // empty the div
    this.minicartContentNotify.innerHTML = '';
  }

  bindEvents() {
    let ctx = this;

    $('body').on('click.removeProduct', ctx.SELECTORS.remove, function () {
      ctx.removeProduct(this);
    });
    // quick cart close on dom click
    document.addEventListener('click',(e)=>{
      // if is open and i click outside the notification, close it
      if (this.minicartContentNotify.classList.contains(this.CLASSES.minicartOpened) && e.target.closest(this.SELECTORS.minicartContentNotify) == null ) {
        this.closeMinicartNotification();
      }
    });

  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }

}
